import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrash } from '@fortawesome/free-solid-svg-icons';
import cn from 'classnames';
import { formatDateTimeUA } from 'helpers/formatDate';
import { MoneyAmount } from 'components/MoneyAmount';
import { Modal } from 'components/Modal';
import styles from '../CashRegister.scss';

export const GroupedTransactionModal = ({ selectedGroup, setSelectedGroup, handleDeleteTransaction }) => (
  <Modal isOpen={selectedGroup} setIsOpen={setSelectedGroup}>
    <h3>Деталі об'єднаної транзакції</h3>
    <div className={styles.groupSummary}>
      <div className={styles.groupSummaryItem}>
        <span>Платник:</span>
        <strong>
          {selectedGroup?.payer?.surname} {selectedGroup?.payer?.name}
        </strong>
      </div>
      <div className={styles.groupSummaryItem}>
        <span>Спосіб оплати:</span>
        <strong>{selectedGroup?.method?.label}</strong>
      </div>
      <div className={styles.groupSummaryItem}>
        <span>Загальна сума:</span>
        <strong>
          <MoneyAmount value={selectedGroup?.amount || 0} />
        </strong>
      </div>
      <div className={styles.groupSummaryItem}>
        <span>Кількість операцій:</span>
        <strong>{selectedGroup?.groupedCount}</strong>
      </div>
    </div>
    <div className={styles.groupTransactions}>
      <h4>Список транзакцій:</h4>
      {selectedGroup?.originalTransactions?.map((transaction, index) => (
        <div key={transaction.id} className={styles.groupTransactionItem}>
          <div className={styles.transactionIndex}>#{index + 1}</div>
          <div className={styles.transactionDetails}>
            <div>{transaction.description}</div>
            <div className={styles.transactionMeta}>
              {formatDateTimeUA(transaction.createdAt, true)} • {transaction.operator?.surname}{' '}
              {transaction.operator?.name?.[0]}.
            </div>
          </div>
          <div
            className={cn(styles.transactionAmount, {
              [styles.expense]: transaction.type === 'expense' || transaction.type === 'transfer_out',
            })}
          >
            <MoneyAmount
              value={
                transaction.type === 'expense' || transaction.type === 'transfer_out'
                  ? -transaction.amount
                  : transaction.amount
              }
            />
          </div>
          <div className={styles.transactionActions}>
            <button
              onClick={() => {
                handleDeleteTransaction(transaction.id);
                setSelectedGroup(null);
              }}
              className={styles.deleteBtn}
            >
              <FontAwesomeIcon icon={faTrash} />
            </button>
          </div>
        </div>
      ))}
    </div>
  </Modal>
);
